import React from 'react';

import { Avatar, Button, Input, List, Tag } from 'antd';

import debounce from 'debounce';

import { _getSearchEnterprise } from '../../services';

class EnterpriseSelector extends React.PureComponent{

	state = {
		data: []
	}

	render(){

		const { data } = this.state;

		return (
			<div>
				<Input onChange={ this.handleOnSearch } placeholder="Search Company Name"/>
				
				<List 
					dataSource={data}

					renderItem={ item => (
						<List.Item 
							style={{
								background: this.props.selectedEnterprise && this.props.selectedEnterprise._id === item._id ? "aliceblue": "inherit"
							}}
							itemLayout="horizontal"
							actions={[
								<Button onClick={ () => this.props.onSelect( item ) }>Select</Button>
							]}>
							
							<List.Item.Meta

								avatar={(
									<Avatar>
										{item.companyName.split(' ').slice(0,2).reduce( ( acc, cur ) => { return `${acc}${cur.substr(0,1)}`}, '')}
									</Avatar>
								)}
								style={{ 
									width: "100%"
								}}
								description={<div>{item.creditTermDays} Days Term | Up to ${item.creditTermAmount}.00</div>}
								title={<div>{item.companyName}{ item.government? <Tag style={{ marginLeft: 8 }} color="geekblue" >Gov</Tag>:null}</div>}
							/>

						</List.Item>
					)}
		
					/>
			</div>
		)
	}

	constructor( props ){
		super(props);

		this.doAsyncSearch = debounce(this.doAsyncSearch, 900);
	}

	doAsyncSearch = ( searchParam ) => {
		this.props.clearSelected();

		if( !searchParam ){
			return this.setState({ data: [] });
		}

		_getSearchEnterprise( searchParam )
			.then( res => {
				this.setState({
					data: res.data.docs
				})
			})
	}

	handleOnSearch = ( e ) => {
		this.doAsyncSearch( e.target.value );
	}

}

export default EnterpriseSelector;


// WEBPACK FOOTER //
// ./src/components/enterprise/list-selector.js